import React from 'react'
import styles from '../Hero.css'
import {TypeCTA} from "../../../constants/consts-prop-types"
import LinkDuo from "../../LinkDuo/LinkDuo"


const CTAs = React.forwardRef((props, ref) => {
  const { cta_primary, cta_secondary, cta_title } = props

  return (
    <div
      ref={ref}
      className={[styles.ctas, !ref ? styles["ctas_animation_none"] : ""].join(
        " "
      )}
    >
      {cta_primary && cta_primary.url &&
      <LinkDuo
        className='button primary'
        aria-label={[cta_primary.label, cta_title].join(' ')}
        to={cta_primary.url}
      >
        {cta_primary.label}
      </LinkDuo>
      }
      {cta_secondary && cta_secondary.url &&
      <LinkDuo
        className='button secondary'
        aria-label={[cta_secondary.label, cta_title].join(' ')}
        to={cta_secondary.url}
      >
        {cta_secondary.label}
      </LinkDuo>
      }
    </div>
  )
})

CTAs.propTypes = {
  cta_primary: TypeCTA,
  cta_secondary: TypeCTA,
}

export default CTAs



// WEBPACK FOOTER //
// ./src/components/Hero/partials/CTAs.js